import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AccountValueHistoryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AccountValueHistoryError', ...args);
    }
}
export default AccountValueHistoryError;
